import React, {Component} from "react";
import {List} from "antd";
import DealerListItem from "./DealersListItem";

class DealersList extends Component {

  render = () => {
    const {loading, dataSource, ...rest} = this.props;

    return (
      <div>
        <List className="dealer-list" loading={loading} dataSource={dataSource} renderItem={item => (
          <DealerListItem item={item} {...rest}/>
        )}/>
      </div>
    );
  }
}

export default DealersList;



// WEBPACK FOOTER //
// ./src/components/call-center/dealer/DealersList.js